import { useMemo } from "react";

import { parseISO } from "date-fns";

import { useTablePagination } from "components/Table/hooks";

const getSharedResourceHistory = ({ page, pageSize = 10 }) => {
  const query = `query getSharedResourceHistory($processId: ID!) {
  sharedResourceRecipients(processId: $processId, first: ${pageSize}, offset: ${
    page * pageSize
  }) {
    edges {
      node {
        id
        createdAt
        recipientEmail
        status
        sharedResource {
          sharedBy {
            email
          }
          templateRelease {
            releaseNumber
          }
        }
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}`;

  const resolver = ({ data: { sharedResourceRecipients } }) => {
    return {
      sharedResourceHistory: sharedResourceRecipients.edges.map(({ node }) => {
        return {
          id: node.id,
          sharedBy: node.sharedResource.sharedBy.email,
          version: node.sharedResource.templateRelease.releaseNumber,
          sharedOn: parseISO(node.createdAt),
          sharedWith: node.recipientEmail,
          status: node.status,
        };
      }),
      totalCount: sharedResourceRecipients.totalCount,
    };
  };

  return { query, resolver };
};

const useSharedResourceHistory = (processId) => {
  const {
    pageControl,
    updatePageControl,
    reloadData,
    loading,
    data,
    numOfFetches,
  } = useTablePagination(getSharedResourceHistory, {
    variables: useMemo(() => {
      return { processId };
    }, [processId]),
  });

  return {
    pageControl: pageControl,
    updatePageControl: updatePageControl,
    initialLoading: loading && numOfFetches === 0,
    isReloading: loading && numOfFetches > 0,
    totalCount: data?.totalCount || 0,
    sharedResourceHistory: data?.sharedResourceHistory || [],
    reloadData: reloadData,
  };
};

export default useSharedResourceHistory;
